import { LoaderProps } from './Loader.types'
import React from 'react'
import { LoaderContainer } from './Loader.styles'
import LoaderAnimation from '../../../assets/icons/loader.svg'

const Loader: React.FC<LoaderProps> = ({ style, light }) => {
  return (
    <LoaderContainer style={style}>
      <img src={LoaderAnimation} alt="" style={{ maxWidth: '64px', color: light ? '#fff' : '#001640', ...style }} />
    </LoaderContainer>
  )
}

export default Loader
